import { type ApiResponse } from "apisauce"

import { encryptedData, request } from "../../../services/api.ts"
import { createFormDataNested } from "../../../utils/form-data/create-form-data-nested"
import {
  type ConfirmChangeEmailParams,
  type RequestAccountDeletionParams,
  type RequestChangeEmailParams,
  type UpdatePasswordParams,
  type UpdateUserParams
} from "./types.ts"

const BASE_URL = "/user/users"

const PATHS = {
  getUser: (id: string) => `${BASE_URL}/${id}/`,
  updateUser: (id: string) => `${BASE_URL}/${id}/`,
  deleteMyAccount: `${BASE_URL}/delete-my-account/`,
  deletionStatus: `${BASE_URL}/delete-my-account/status/`,
  cancelMyDeletion: `${BASE_URL}/delete-my-account/cancel/`,
  updatePassword: `${BASE_URL}/change-password/`,
  requestChangeEmail: `${BASE_URL}/request-email-change/`,
  confirmChangeEmail: `${BASE_URL}/confirm-email-change/`
}

export const updateUser = ({
  id,
  team,
  ...data
}: UpdateUserParams): Promise<ApiResponse<any>> => {
  const params = team ? { team } : undefined

  if (!data?.avatar && !data?.company_details?.logo) {
    return request.api.patch(PATHS.getUser(id), encryptedData(data), { params })
  }

  const headers = { "Content-Type": "multipart/form-data" }
  const formData = createFormDataNested(data, "data")

  return request.api.patch(PATHS.getUser(id), formData, { headers, params })
}

export const updatePassword = (
  data: UpdatePasswordParams
): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.updatePassword, encryptedData(data))
}

export const requestChangeEmail = (
  data: RequestChangeEmailParams
): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.requestChangeEmail, encryptedData(data))
}

export const confirmChangeEmail = (
  data: ConfirmChangeEmailParams
): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.confirmChangeEmail, encryptedData(data))
}

export const getUser = (
  id: string,
  team?: string
): Promise<ApiResponse<any>> => {
  return request.api.get(PATHS.getUser(id), team ? { team } : undefined)
}

export const requestAccountDeletion = (
  data: RequestAccountDeletionParams
): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.deleteMyAccount, data)
}

export const getDeletionStatus = (): Promise<ApiResponse<any>> => {
  return request.api.get(PATHS.deletionStatus)
}

export const cancelAccountDeletion = (): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.cancelMyDeletion)
}
